// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__ZyCHp","meals-appear":"AvailableMeals_meals-appear__cK+50"};